module.exports = __webpack_public_path__ + "media/Video (17).1cfe7320.mp4";